module.exports = __webpack_public_path__ + "static/media/edited2.7d39a716.svg";